<p-dialog
  [visible]="svc.visible()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [closable]="svc.step() !== 'verifying'"
  [closeOnEscape]="svc.step() !== 'verifying'"
  [header]="svc.actionLabel()"
  [style]="{ width: '26rem', maxWidth: '92vw' }"
  (onHide)="svc.cancel()">

  @if (svc.step() === 'sending') {
    <div class="flex items-center gap-3 py-4 text-sm text-ink-mid dark:text-night-mid">
      <i class="pi pi-spin pi-spinner text-lg"></i>
      <span>Sending a verification code to your phone…</span>
    </div>
  }

  @if (svc.step() === 'otp' || svc.step() === 'verifying') {
    <div class="space-y-5">
      <p class="text-sm text-ink-mid dark:text-night-mid leading-relaxed">
        We sent a 6-digit code to your registered phone number. Enter it below to continue.
      </p>

      <div>
        <label for="mfa-otp" class="block text-sm font-semibold mb-1.5">Verification code</label>
        <input id="mfa-otp" pInputText type="text"
               inputmode="numeric"
               autocomplete="one-time-code"
               maxlength="6"
               autofocus
               [ngModel]="otp()" (ngModelChange)="otp.set($event); svc.inlineError.set(null)"
               (keyup.enter)="confirm()"
               class="w-full p-inputtext-lg tracking-[0.5em] text-center font-mono"
               [class.ng-invalid]="!!svc.inlineError()"
               [class.ng-dirty]="!!svc.inlineError()" />

        @if (svc.inlineError()) {
          <p class="mt-1.5 text-xs text-red-600 dark:text-red-400">{{ svc.inlineError() }}</p>
        }

        <div class="mt-3 flex items-center justify-between text-xs">
          <span class="text-ink-mid dark:text-night-mid">
            @if (svc.secondsLeft() > 0) {
              Code expires in <span class="font-semibold text-ink dark:text-night-text">{{ svc.formatCountdown() }}</span>
            } @else {
              <span class="text-amber-700 dark:text-amber-300">Code has expired.</span>
            }
          </span>
          @if (svc.canResend()) {
            <button type="button" (click)="resend()"
                    class="font-semibold text-green dark:text-green-light hover:underline">
              Resend code
            </button>
          }
        </div>
      </div>

      <p-button
        [label]="svc.step() === 'verifying' ? 'Verifying…' : 'Confirm'"
        icon="pi pi-shield"
        [loading]="svc.step() === 'verifying'"
        [disabled]="!canVerify()"
        (onClick)="confirm()"
        styleClass="w-full !bg-green hover:!bg-green-light dark:!bg-green-light dark:hover:!bg-green-glow !border-0 !text-white !rounded-full !py-3 !font-bold !text-sm disabled:!opacity-50">
      </p-button>
    </div>
  }

  @if (svc.step() === 'phone-missing') {
    <div class="space-y-5">
      <p class="text-sm text-ink-mid dark:text-night-mid leading-relaxed">
        {{ svc.inlineError() ?? 'Your account has no registered phone number. Add one to continue.' }}
      </p>

      <p-button
        label="Manage phone number"
        icon="pi pi-mobile"
        (onClick)="goToManagePhone()"
        styleClass="w-full !bg-green hover:!bg-green-light dark:!bg-green-light dark:hover:!bg-green-glow !border-0 !text-white !rounded-full !py-3 !font-bold !text-sm">
      </p-button>

      <button type="button" (click)="svc.cancel()"
              class="block w-full text-center text-xs font-semibold text-ink-mid dark:text-night-mid hover:underline">
        Cancel
      </button>
    </div>
  }
</p-dialog>
